import { SALARY_UPDATE } from './salaryMasterType';

export const salaryUpdate = (object: any) => {
    return {
        type: SALARY_UPDATE,
        data: object,
    };
};
